export default "__VITE_ASSET__241juuco__"